// extracted by mini-css-extract-plugin
export default {"panePlaceholder":"panePlaceholder---X2Mwe","appIcon":"appIcon---TDnSp"};